import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { Input } from "components/bootstrap";
import FormAdvancedOptions from "./FormAdvancedOptions";
import FormWrap from "../common/FormWrap";
const StepSubscribe = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { checkpointIntervalSeconds } = formData;
  const handleSubmit = () => {
    if (checkpointIntervalSeconds.value < 5) {
      setFormError({
        full_message: t("crowdstrike.errors.checkpoint_interval_invalid"),
        nice_message: t("crowdstrike.errors.checkpoint_interval_min")
      });
      return;
    }
    setFormError(null);
    onSubmit();
  };
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      buttonContent: t("common.buttons.proceed"),
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      Input,
      {
        id: "checkpointIntervalSeconds",
        name: "checkpointIntervalSeconds",
        type: "number",
        value: checkpointIntervalSeconds.value || checkpointIntervalSeconds.defaultValue || "",
        min: "1",
        max: "60",
        step: "1",
        onChange,
        required: true,
        help: t("crowdstrike.fields.checkpoint_interval_help"),
        label: t("crowdstrike.fields.checkpoint_interval")
      }
    ),
    /* @__PURE__ */ React.createElement(FormAdvancedOptions, { onChange })
  );
};
export default StepSubscribe;
